import { action } from 'typesafe-actions';

import ActionTypes from './constants';

export const displayUpperShelfPanelAction = (value: boolean) =>
  action(ActionTypes.DISPLAY_UPPERSHELF_PANEL, { value });

export const addOrUpdateUpperShelfAction = (color: string, preview = false) =>
  action(ActionTypes.ADD_OR_UPDATE_UPPER_SHELF, { color, preview });

export const removeUpperShelfAction = (preview = false) =>
  action(ActionTypes.REMOVE_UPPER_SHELF, { preview });

export const addOrUpdateFurnitureUpperShelfAction = (
  color: string,
  preview = false,
) =>
  action(ActionTypes.ADD_OR_UPDATE_FURNITURE_UPPER_SHELF, { color, preview });

export const removeFurnitureUpperShelfAction = (preview = false) =>
  action(ActionTypes.REMOVE_FURNITURE_UPPER_SHELF, { preview });
